import { render, staticRenderFns } from "./TableDataFetching.vue?vue&type=template&id=2f46266e&scoped=true&"
import script from "./TableDataFetching.vue?vue&type=script&lang=js&"
export * from "./TableDataFetching.vue?vue&type=script&lang=js&"
import style0 from "./TableDataFetching.vue?vue&type=style&index=0&id=2f46266e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f46266e",
  null
  
)

export default component.exports